import React, { useEffect, useState } from 'react';
import { getOutstandingByDepartment } from '../../api/work-orderAPI';

const DepartmentOutstandingTable = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getOutstandingByDepartment();
      setData(result);
    };
    fetchData();
  }, []);

  return (
    <div className="col-xxl-4">
      <div className="card h-100 radius-8 border-0">
        <div className="card-body p-24">
          <h6 className="fw-bold text-lg mb-3">Outstanding Work Orders by Department</h6>
          <div className="table-responsive">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Department</th>
                  <th className="text-end">Outstanding</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.name}</td>
                    <td className="text-end">{row.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartmentOutstandingTable;
